// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"e5fe094a52f339a7","4044":"507bebfe9dc32504","4515":"e5fe094a52f339a7","4969":"c991e493668a24f8","5264":"889b6e383cb18132","8378":"06101e4d0c313e2d"}[chunkId] + ".css";
};